import moment, { Moment } from 'moment';
import { QuickHitsFilter } from 'typings';
import API from 'services/AxiosConfig';
import { toast } from 'react-toastify';
import { mutipleManagerRowFormat } from './generateRows';


export function colorCode(date: string) {
  if (!date) return '#295faa';
  const differenceInDays = moment.utc(date).startOf('day').diff(moment.utc().startOf('day'), 'days');
  if (moment(date.replace(/-/g, '\/').replace(/T.+/, '')) > moment() && differenceInDays > 7) {
    return '#295faa';
  } else if (differenceInDays > 0) {
    return '#96ca53';
  } else {
    return '#f44336';
  }
}
const isValidObjectId = (id: any) => {
  return /^[a-f\d]{24}$/i.test(id);
};
export function colorCodeApplicant(days: any) {
  if (days === 'N/A') return "black"
  if (days > 30) {
    return '#f44336';
  }
  if (days > 10) {
    return '#295faa';
  } else {
    return '#96ca53';
  }
}

export function formatDate(date: string,) {
  //return moment(date).local().format('MM/DD/YYYY');
  return moment.utc(date).local().format('MM/DD/YYYY');
}

export function formatDateMonthDate(date: string) {
  if (!date) return '';
  const value = moment.utc(date).local();
  return value.isValid() ? value.format('MM/DD') : '';
}
export function formatCMDate(date: string) {
  if (!date) return '';

  // Create a Moment.js date object in UTC
  const newDate = moment.utc(date);

  // Format the date in MM/DD/YYYY format
  return newDate.format('MM/DD/YYYY');
}
export function formatCMDay(date: string) {
  if (!date) return '';
  const newDate = moment.utc(date);
  return newDate.format('dddd');
}

export function formatCMDateDay(date: string) {
  if (!date) return '';
  const newDate = moment(date);
  return newDate.format('MM/DD/YYYY, dddd');
}


export function formatDateTime(date: string) {
  const parsedDate = moment(date);
  if (parsedDate.isValid()) {
    return parsedDate.format('hh:mma');
  } else {
    return '';
  }
}
export function isMidnight(dateStr: string) {
  const parsedDate = moment(dateStr);

  if (!parsedDate.isValid()) return false;

  const hours = parsedDate.hours();
  const minutes = parsedDate.minutes();
  const seconds = parsedDate.seconds();

  return hours === 0 && minutes === 0 && seconds === 0;
};
export function formatTime(date: string): string {
  const parsedDate = moment.utc(date).local();  // ensure from UTC to local
  return parsedDate.isValid() ? parsedDate.format('hh:mma') : '';
}
export function formatName(firstName: string, lastName: string) {
  if (!firstName || !lastName) return ''
  return `${firstName?.trim()} ${lastName?.trim()}`;
}

export function formatLocationString(location: any): string {
  if (Array.isArray(location) && location.length > 0) {
    return location.map(loc => loc.location || loc.name || loc).join(', ');
  } else if (typeof location === 'string') {
    return location;
  } else if (location && typeof location === 'object') {
    return location.location || location.name || '';
  }
  return '';
}

const getISOString = (date: string | Moment, type?: boolean) => {
  if (!moment.isMoment(date)) {
    return moment(date).endOf('day').toISOString();
  }
  if (type) {
    return date.endOf('day').toISOString();
  };
  return moment(date).toISOString();
};

type Range = {
  startDate: string;
  endDate: string;
};

export function
  generateUrl(type: string, filter: any, userId?: string, query: string = '', locations?: any[], limit?: any, page?: any) {

  let range: Range = { startDate: '', endDate: '' };
  const { startDate, endDate, dateRange, activity } = filter;

  if (dateRange?.value !== 'All' && startDate && endDate) {
    // range = { startDate: getISOString(startDate.value), endDate: getISOString(endDate.value) };
    range = {
      startDate: moment(startDate).startOf('day').toISOString(),
      endDate: moment(endDate).endOf('day').toISOString()
    };
  }
  let loc: any = []
  if (locations) {
    loc = locations.map((locationObj) => {
      return locationObj?._id
    })
  }
  loc = loc.join(',')

  if (type === 'current-notes') {
    return `/${type}?careManagerId=${filter?.careManager.value !== 'All' ? filter?.careManager.value : ''}&locationId=${filter?.location.value !== '0' ? filter?.location.value : loc
      }&active=${filter?.status.value === 'Active'}&startDate=${range?.startDate}&endDate=${range?.endDate}${query}`;
  }

  if (type === 'client') {
    return `/${type}?locationId=${filter?.location?.value !== '0' ? filter?.location?.value : loc}&careManagerId=${filter?.careManager?.value !== 'All' ? (filter?.careManager?.value !== '' ? filter?.careManager?.value : filter?.careManager?.value) : ''
      }&status=${filter?.status?.value}&clientStr=${filter?.client?.label}&numDays=${filter?.flag === true}`;
  }

  if (type === 'care-partner') {
    return `/${type}?locationId=${filter?.location?.value !== '0' ? filter?.location?.value : loc}&status=${filter?.status?.value
      }&carePartnerStr=${filter?.carePartner?.value}&manager=${filter?.manager?.value}&numDays=${filter?.flag === true}`;
  }
  if (type === 'clientV2') {
    return `/client/V2?locationId=${filter?.location?.value !== '0' ? filter?.location?.value : loc}&careManagerId=${filter?.careManager?.value !== 'All' ? (filter?.careManager?.value !== '' ? filter?.careManager?.value : filter?.careManager?.value) : ''
      }&status=${filter?.status?.value}&clientStr=${filter?.client?.label === "All" ? "" : filter?.client?.label}&numberOfMonths=${filter?.numberOfMonths.value}&priorityIndex=${filter?.priorityIndex?.value !== undefined ? filter?.priorityIndex?.value : 0}&tags=${filter?.tags?.value}&groupBy=${filter?.groupByClient?.value}`;
  }

  if (type === 'care-partnerV2') {
    return `/care-partner/V2?locationId=${filter?.location?.value !== '0' ? filter?.location?.value : loc}&status=${filter?.status?.value
      }&carePartnerStr=${filter?.carePartner?.value}&manager=${filter?.manager?.value}&numberOfMonths=${filter?.numberOfMonths.value}&priorityIndex=${filter?.priorityIndex?.value !== undefined ? filter?.priorityIndex?.value : 0}&tags=${filter?.tags?.value}`;
  }


  if (type === 'applicants' || type === 'applicants/V2/') {
    // return `/${type}?location=${filter.location.value}&name=${filter.name?.value}&status=${filter.status?.id}&stage=${filter.stage?.id}&startDate=${range.startDate ? moment(range.startDate).format('YYYY-MM-DD') : ''}&endDate=${range.endDate ? moment(range.endDate).endOf('day') : ''}&locationId=${loc}&radioSelected=${query}&flag=${filter.flag === true}`;
    return `/${type}?location=${filter?.location.label !== '0' ? filter?.location.label : loc}&name=${filter?.name?.value ?? ''}&status=${filter?.status?.value}&stage=${filter?.stage?.value ?? ''}&startDate=${range?.startDate ?? ''}&endDate=${range?.endDate ?? ''}&locationId=${loc}&radioSelected=${query}&flag=${filter?.flag === true}&manager=${filter?.manager?.value}&groupBy=${filter?.groupBy?.value}`;
  }
  if (type === 'award-management') {
    return `/${type}?award=${filter?.awardType?.value}&careManager=${filter?.careManager?.value}&carePartner=${filter?.carePartner?.value}&startDate=${range.startDate}&endDate=${range.endDate}${query}&location=${filter.location.value !== '0' ? filter.location.value : loc}&locationId=${loc}&groupBy=${filter.groupBy.value}`
  }
  if (type === 'award-managementV2') {
    return `/award-management/V2?award=${filter?.awardType?.value}&careManager=${filter?.careManager?.value}&carePartner=${filter?.carePartner?.value}&startDate=${range.startDate}&endDate=${range.endDate}${query}&location=${filter.location.value !== '0' ? filter.location.value : loc}&locationId=${loc}&groupBy=${filter.groupBy.value}`
  }
  let locationId = '';
  if (filter?.location?.value !== '0') {
    locationId = filter.location.value;
  } else {
    locationId = loc
  }

  if (type === 'care-manager-activity-event') {
    const clientId = filter?.client?.value ? isValidObjectId(filter?.client?.value) : '';
    return `/${type}?locationId=${locationId}&careManagerId=${filter?.careManager.value !== 'All' ? (filter.careManager.value !== '' ? filter.careManager.value : filter.careManager.value) : ''
      }&active=${filter.status.value === 'All' ? '' : filter.status.value === 'Active'}&activity=${activity?.id === undefined || activity?.id === 'All' ? '' : activity?.id}&startDate=${range.startDate}&endDate=${range.endDate}&flag=${filter?.flag === true
      }${query}&*limit=${limit || ''}&page=${page || ''}&client=${filter?.client?.value || 'All'}&clientId=${filter?.clientId?.value || (clientId ? filter?.client?.value : '')}&carePartner=${filter?.carePartner?.value || ''}&carePartnerId=${filter?.carePartnerId?.value || ''}`;
  }
  if (type === 'care-manager-activity-event_calendar') {
    return `/care-manager-activity-event/V2/?locationId=${locationId}&careManagerId=${filter?.careManager.value !== 'All' ? filter?.careManager.value : ''
      }&active=${filter?.status.value === 'All' ? '' : filter?.status.value === 'Active'}&activity=${activity?.id === undefined || activity?.id === 'All' ? '' : activity?.id}&startDate=${filter?.startDate || ''}&endDate=${filter?.endDate || ''}&flag=${filter?.flag === true
      }${query}&*limit=${limit || ''}&page=${page || ''}&client=${filter?.client?.value || ''}&carePartner=${filter?.carePartner?.value || ''}&priorityIndex=${filter?.priorityIndex?.value !== undefined ? filter?.priorityIndex?.value : 0}`;
  }
  if (type === 'care-manager-task') {
    return `/care-manager-activity-event/V2/?locationId=${locationId}&careManagerId=${filter?.careManager.value !== 'All' ? filter?.careManager.value : ''
      }&activity=${activity?.id === undefined || activity?.id === 'All' ? '' : activity?.id}&startDate=${range?.startDate}&endDate=${range?.endDate}&flag=${filter?.flag === true
      }${query}&*limit=${limit || ''}&page=${page || ''}&client=${filter?.client?.value || ''}&carePartner=${filter?.carePartner?.value || ''}&priorityIndex=${filter?.priorityIndex?.value !== undefined ? filter?.priorityIndex?.value : 0}`;
  }
  return `/${type}?locationId=${locationId}&careManagerId=${filter?.careManager.value !== 'All' ? filter?.careManager.value : ''
    }&active=${filter?.status.value === 'All' ? '' : filter?.status.value === 'Active'}&activity=${activity?.id === undefined || activity?.id === 'All' ? '' : activity?.id}&startDate=${range?.startDate}&endDate=${range?.endDate}&flag=${filter?.flag === true
    }${query}&*limit=${limit || ''}&page=${page || ''}&client=${filter?.client?.value || ''}&carePartner=${filter?.carePartner?.value || ''}`;
}

export const status = ['Active', 'Inactive'];

export function renderColor(date: string) {

  if (moment(date).startOf('day') <= moment().startOf('day')) {
    return 'red';
  }
  const next7Days = moment().startOf('day').add(7, 'd');
  if (moment(date).startOf('day') < next7Days) {
    return 'green';
  }
  return 'blue';
}

export const quickHitsTypes = ['Client', 'Care Partner'];

export const quickHitsFilter: QuickHitsFilter = {
  flag: false,
  location: { value: '0', label: 'All' },
  careManager: { value: 'All', label: 'All' },
  status: { value: 'Active', label: 'Active' },
  dateRange: { value: 'All', label: 'All' },
  startDate: { value: '', label: '' },
  endDate: { value: '', label: '' },
};

export const handleUnarchive = (type: any, id: string, closingComments: string) => {
  API.put(`${type}/unarchive/${id}`, { closingComments })
    .then((rsp) => {
      if (rsp.data.success) {
        toast.success('Successfully Reactivated.');
      }
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to archive.');
    });
};


export const sort = (data: any[], sortVal: string, type: string, ascending: boolean, origin: string) => {
  if (sortVal === 'Due Date') type = 'date'
  if (sortVal === 'Created') sortVal = 'createdAt';
  if (sortVal === 'Due Date' || sortVal === 'Date Due') sortVal = 'dueDate';
  if (sortVal === 'Care Partner') sortVal = 'carePartnerObj';
  if (sortVal === 'Date') sortVal = 'date';
  if (sortVal === 'Care Manager') sortVal = 'careManager';
  if (sortVal === 'Client') sortVal = 'clientObj';
  if (sortVal === 'Name') {
    sortVal = origin === 'applicants' ? 'fullName' : 'name'
  }
  if (sortVal === 'Created By') sortVal = 'createdBy'
  if (sortVal === 'Date Created') sortVal = 'createdAt'
  if (sortVal === 'Last Activity') {
    sortVal = origin === 'applicants' ? 'lastActivityAt' : 'lastActivity'
  }
  if (sortVal === 'Follow-Up Date') sortVal = 'followupDate';
  if (sortVal === 'Full Name') sortVal = 'fullName';
  if (sortVal === 'Email') sortVal = 'email';
  if (sortVal === 'Source') sortVal = 'source';
  if (sortVal === 'Active Date') {
    sortVal = 'activeDate'
  }

  if (sortVal === 'Activity') sortVal = 'activity'
  if (sortVal === 'Completed By') sortVal = 'completedBy'
  if (sortVal === 'Date Completed') sortVal = 'completedAt'
  if (sortVal === 'Date Created') sortVal = 'dateCreated'
  if (sortVal === 'Inquiry Date') sortVal = 'initialContactDate'
  if (sortVal === 'Stage') sortVal = 'stage'
  if (sortVal === 'Status') sortVal = 'status'
  if (sortVal === 'InactiveDate') sortVal = 'inactiveDate'

  if (origin === 'prospects') {
    if (sortVal === 'name') {
      sortVal = 'fullName'
    } else if (sortVal === 'lastActivity') {
      sortVal = 'lastActivityAt'
    }
  }
  if (origin === 'careManagerActivities') {
    if (sortVal === 'dueDate') {
      sortVal = 'date'
    }
  }
  if (origin === 'careManagerActivities') {
    if (sortVal === 'dueDate') {
      sortVal = 'date'
    }
  }
  if (origin === 'marketing-activities') {
    if (sortVal === 'Completed Date') {
      sortVal = 'date'
      type = 'date'
    }
    if (sortVal === 'Activity Type') {
      sortVal = 'activity'
    }
  }

  if (type === 'date' && ascending) {
    if (sortVal === 'lastActivityAt' || sortVal === 'initialContactDate' || (sortVal === 'activeDate' && origin === 'prospects')) return (data.slice().sort((a: any, b: any) => {
      return +new Date(a[sortVal]) - +new Date(b[sortVal])
    }))
    return data.slice().sort((a: any, b: any) => +new Date(a[sortVal]?.value) - +new Date(b[sortVal]?.value));
  }
  if (type === 'date' && !ascending) {
    if (sortVal === 'lastActivityAt' || sortVal === 'initialContactDate' || sortVal === 'activeDate') return data.slice().sort((a: any, b: any) => +new Date(b[sortVal]) - +new Date(a[sortVal]))
    return data.slice().sort((a: any, b: any) => +new Date(b[sortVal]?.value) - +new Date(a[sortVal]?.value));
  }
  if (type === 'alphabetical') {
    return data.slice().sort((a: any, b: any) => {
      let nameA;
      let nameB
      if (sortVal === 'fullName' || sortVal === 'name' || sortVal === 'activity' || sortVal === 'createdBy' || sortVal === 'completedBy' || sortVal === 'email' || sortVal == 'stage' || sortVal === 'status') {
        nameA = a[sortVal]?.value?.toUpperCase() || a[sortVal];
        nameB = b[sortVal]?.value?.toUpperCase() || b[sortVal];
      } else {
        nameA = a?.state.value[sortVal]?.firstName || ''
        nameB = b?.state.value[sortVal]?.firstName || ''
      }
      if (nameA === 'Invalid date' || nameB === 'invalidDate') {
        return ascending ? -1 : 1;
      }
      if (nameA < nameB) {
        let val = ascending ? -1 : 1;
        return val;
      }
      if (nameA > nameB) {
        let val = ascending ? 1 : -1;
        return val;
      }
      return 0;
    });
  }
};

export const applicantSort = (data: any, sortVal: string, type: string, ascending: boolean, origin: string) => {
  return data.map((obj: any) => {
    return { location: obj.location, data: sort(obj.data, sortVal, type, ascending, origin), count: obj.count };
  });
};

export const careManagerSort = (data: any, sortVal: string, type: string, ascending: boolean, origin: string, multipleManagers: boolean, groupBy?: any) => {
  let rows = multipleManagers && (groupBy && groupBy !== 'None' || groupBy?.value && groupBy.value !== 'None') ? mutipleManagerRowFormat(data, groupBy) : data
  if (multipleManagers && (groupBy !== 'None' && groupBy.value !== 'None')) {
    return rows.map((obj: any) => {
      let sortedData = sort(obj.data, sortVal, type, ascending, origin)
      return { location: obj.location, data: sortedData, count: sortedData?.length };
    });
  } else {
    return sort(data, sortVal, type, ascending, origin)
  }
};

export const fetchApplicantName = async (id: string, setApplicantName: any) => {
  API.get(`/applicants/applicant/${id}`)
    .then(({ data }) => {
      const { fullName } = data.data;
      setApplicantName(fullName);
    })
    .catch((error) => {
      console.log(error);
      toast.error('Failed to get applicant');
    })
};

export const fetchActivities = async (type: any, id: any, callback: any, formatter?: any) => {
  API.get(`/applicants/activities/${id}/?type=${type}`)
    .then((rsp) => {
      if (formatter) {
        callback(formatter(rsp.data.data))
        return
      }
      callback(rsp.data.data);
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get activities');
    });
};

export const fetchProspectActivities = async (type: any, id: any, callback: any, setLoading: any, formatter?: any) => {
  setLoading(true)
  API.get(`/prospects/activities/${id}/?type=${type}`)
    .then((rsp) => {
      if (formatter) {

        callback(formatter(rsp.data.data))
        setLoading(false)
        return
      }
      setLoading(false)
      callback(rsp.data.data);
      setLoading(false)
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get activities');
      setLoading(false)
    });
};
export const findCompanyKey = (obj: any) => {
  for (const key in obj) {
    if (key.includes('company') && key !== 'companyType') {
      return key;
    }
  }

  // Return null if no matching key is found
  return null;
}
export const fetchReferralPartnerActivities = async (type: any, id: any, callback: any, formatter?: any) => {
  API.get(`/referral-partners/activities/${id}/?type=${type}`)
    .then((rsp) => {
      if (formatter) {
        callback(formatter(rsp.data.data))
        return
      }
      callback(rsp.data.data);
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get activities');
    });
};

export const fetchSources = async (callback: any) => {
  API.get('/applicants/sources')
    .then((rsp) => {
      callback(rsp.data.data);
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get stages');
    });
}

export const fetchStages = async (callback: any) => {
  API.get('/applicants/stages')
    .then((rsp) => {
      let data = rsp.data.data
      let dividerFound: boolean | null = null
      data = data.map((item: any, idx: any, arr: any) => {
        if (arr[idx + 1]?.status === false && dividerFound === null) {
          dividerFound = true
          return { ...item, divider: true }
        }
        return item
      })
      callback(data);
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get stages');
    });
}

export const fetchProspectStages = async (callback: any) => {
  API.get('/prospects/stages')
    .then((rsp) => {
      let data = rsp.data.data
      let dividerFound: boolean | null = null
      data = data.map((item: any, idx: any, arr: any) => {
        if (arr[idx + 1]?.status === false && dividerFound === null) {
          dividerFound = true
          return { ...item, divider: true }
        }
        return item
      })
      callback(data);
    })
    .catch((error) => {
      console.error(error);
      toast.error('Failed to get stages');
    });
}
export const dateCalulator = (condition: any, date: any) => {
  if (!condition) return ''
  let timeOption: any = condition[condition.length - 1]
  if (timeOption.toLowerCase() === 'm') {
    timeOption = 'Months'
  } else {
    timeOption = "Days"
  }
  let timeDifference: any = condition.slice(0, condition.length - 1)
  let today = moment(date)
  return today.add(Number(timeDifference), timeOption)
}
export const customDate = (dateString: any) => {
  const datePart = dateString?.split(',')[0].trim();
  //return moment(datePart, 'MM/DD/YYYY').utc().toDate();
  const newDate = moment.utc(datePart);
  return newDate.format('MM/DD/YYYY');
};

export const isAdmin = (roles: any[]) => {
  let admin = roles?.find((role: any) => role.role === 'Super Administrator')
  return !!admin
}


export const emailHandler = async (values: any, tableSource: string, sendTo = []) => {
  const email = await API.post('/email', { values: values, tableSource: tableSource, sendTo: sendTo })
  return email
}

export const numberToMonth = (str: any) => {
  const months: any = {
    '1': 'January',
    '2': 'February',
    '3': 'March',
    '4': 'April',
    '5': 'May',
    '6': 'June',
    '7': 'July',
    '8': 'August',
    '9': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  };

  return months[str];
}
export const uniqueId = (prefix = 'id-') => {
  const randomPart = Math.random().toString(16).substring(2);
  const timestamp = Date.now().toString(16);
  return `${prefix}${randomPart}-${timestamp}`;
};
export const mergeDateAndTime = (date: Date, tm: Date) => {
  if (!date || !tm) return null;

  const merged = new Date(date);
  const time = new Date(tm);
  // if (isNaN(time.getTime())) {
  //   time = new Date(time);
  // }
  merged.setHours(time.getHours());
  merged.setMinutes(time.getMinutes());
  merged.setSeconds(time.getSeconds());
  merged.setMilliseconds(time.getMilliseconds());
  return merged;
};
// export function utcDate(date1: Date): string {
//   if (!date1 || isNaN(new Date(date1).getTime())) return ''; // Handle undefined/null cases

//   const date = new Date(date1);  // Convert to Date object if not already
//   const utcDate = date.toISOString();  // Convert to UTC format

//   console.log("UTC Date:", utcDate);
//   return utcDate;
// }
export function utcDate(date1: Date): string {
  if (!date1 || isNaN(new Date(date1).getTime())) return '';
  return new Date(date1).toISOString();  // This is correct for storing UTC
}
export const formatTimeString = (time: string) => {
  if (time && time !== "None") {
    // Normalize the time string (e.g. "02:30 PM", "2:30 am", etc.)
    const trimmedTime = time.trim().toUpperCase(); // "02:30 PM"
    const isPM = trimmedTime.includes("PM");
    const isAM = trimmedTime.includes("AM");

    // Remove AM/PM for parsing
    const cleanTime = trimmedTime.replace(/AM|PM/, "").trim();

    const [rawHours, rawMinutes] = cleanTime.split(":").map(val => parseInt(val, 10));
    let hours = rawHours;
    const minutes = rawMinutes || 0;

    // Adjust hours for 12-hour format
    if (isPM && hours < 12) {
      hours += 12;
    } else if (isAM && hours === 12) {
      hours = 0; // 12 AM is 00:00 in 24-hour format
    }

    const today = new Date();
    const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
    return date;
  }
};
export const processDateAndTimeField = <
  T extends Record<string, any>,
  K extends keyof T,
  L extends keyof T
>(
  object: T,
  dateField: K,
  timeField?: L
) => {
  if (timeField && object?.[timeField]) {
    if (object[timeField] === "None") {
      object[timeField] = "" as T[L];
    } else if (object[timeField] !== "") {
      const merged = mergeDateAndTime(object[dateField] as any, object[timeField] as any);
      if (merged) {
        const utc = utcDate(merged);
        object[dateField] = utc as T[K];
        object[timeField] = utc as T[L];
      }
    }
  } else if (object?.[dateField]) {
    object[dateField] = utcDate(object[dateField]) as T[K];
  }
};
export const generateData = (data2: any, dtype = "") => {
  let data1 = data2.data;
  if (dtype === "delta" && data1?.rows.length > 10) {
    data1.rows = data1.rows.slice(0, 10);
  }
  const chartData: any[] = [];
  let headers = data2.data?.headers.filter((item: any) => item.subHeaders !== undefined && item.label !== "Total");
  //headers = headers?.map((a: any) => a.label);
  //headers = headers.map((a: any) => a);


  headers = headers.map((header: any) => {
    if (typeof header === 'object' && header !== null && 'label' in header) {
      return header.label;
    }
    else if (typeof header === 'object' && header !== null && 'subHeaders' in header) {
      return header.subHeaders[0];
    }
    return header;
  });

  const maxLength = Math.max(...data1?.rows.map((item: { values: string | any[]; }) => item.values.length));
  const sums = new Array(maxLength).fill(0);
  let activity: any[] = [];
  let refferal: any[] = [];
  const newHeader: any[] = [];
  data1?.rows.forEach((item: { label: any; values: any[]; }) => {
    if (item.label) {
      newHeader.push(item.label);
    }
    if (dtype === "by_targetmarket_category") {
      const sumActivity = item.values.reduce((acc: number, num: number, index: number) => {
        return index % 2 === 0 ? acc + num : acc;
      }, 0);

      const sumReferral = item.values.reduce((acc: number, num: number, index: number) => {
        return index % 2 !== 0 ? acc + num : acc;
      }, 0);
      activity.push(sumActivity);
      refferal.push(sumReferral);
    }
    else {
      item.values.forEach((value, index) => {
        const num = typeof value === 'string' ? parseFloat(value) : value;
        sums[index] += num;

        if (dtype === "delta") {
          if (!chartData[index]) {
            chartData[index] = "";
          }
          if (chartData[index]) {
            chartData[index] += ",";
          }
          chartData[index] += num;
        }
      });
    }
  });
  if (dtype === "delta") {
    chartData.forEach((element, index) => {
      if (index === 0 || index === 1 || index === 2) {
        activity.push(element);
      }
      else {
        refferal.push(element);
      }
    });

  }
  else {
    if (dtype !== "industry_category") {
      sums.forEach((element, index) => {
        if (index % 2 === 0) {
          activity.push(element);
        }
        else {
          refferal.push(element);
        }

      });
    }
    else if (dtype === "industry_category") {
      sums.forEach((element, index) => {
        if (index === 0 || index === 1 || index === 2) {
          activity.push(element);
        }
        else {
          refferal.push(element);
        }
      });
    }
  }



  return { headers: headers, activity: activity, refferal: refferal, all: sums, actirefertypeheader: newHeader, api: data2 }
};

export const transformDataToMilestones = (data: any) => {
  const result = data.progress.flatMap((progressItem: any) => {
    return progressItem.cardItems.map((cardItem: any) => {
      return {
        //key: cardItem._id || cardItem.label.toLowerCase().replace(/\s+/g, '_'),
        key: cardItem.label.toLowerCase().replace(/\s+/g, '_'),
        label: cardItem.label,
        stage: progressItem?.cardName?.stage,
        value: progressItem?.cardName?.stage
      };
    });
  });
  // console.log("transformDataToMilestones--");
  // console.log(result);
  return result;
};
// export const parseTimeToDate = (timeString: string): Date | null => {
//   if (!timeString || typeof timeString !== 'string') return null;

//   // Normalize and extract time and modifier using RegExp
//   const match = timeString.trim().toLowerCase().match(/^(\d{1,2}:\d{2})(am|pm)$/i) ||
//                 timeString.trim().toLowerCase().match(/^(\d{1,2}):(\d{2})(am|pm)$/i);

//   if (!match) return null;

//   let hours: number;
//   let minutes: number;
//   let modifier: string;

//   if (match.length === 3) {
//     // Match: ["06:30pm", "06:30", "pm"]
//     [ , timeString, modifier ] = match;
//     [hours, minutes] = timeString.split(':').map(Number);
//   } else if (match.length === 4) {
//     // Match: ["6:30pm", "6", "30", "pm"]
//     hours = parseInt(match[1]);
//     minutes = parseInt(match[2]);
//     modifier = match[3];
//   } else {
//     return null;
//   }

//   if (isNaN(hours) || isNaN(minutes)) return null;

//   // Convert to 24-hour format
//   if (modifier === 'pm' && hours < 12) hours += 12;
//   if (modifier === 'am' && hours === 12) hours = 0;

//   const now = new Date();
//   now.setHours(hours, minutes, 0, 0);

//   return now;
// };


export const parseTimeToDate = (timeString: string): Date | null => {
  if (!timeString || typeof timeString !== "string") return null;

  const trimmed = timeString.trim();

  // Case 1: ISO date string (e.g., "2025-08-10T11:20:00.086Z")
  if (!isNaN(Date.parse(trimmed))) {
    return new Date(trimmed);
  }

  // Case 2: 12-hour time string (e.g., "02:30pm")
  const match =
    trimmed.toLowerCase().match(/^(\d{1,2}):(\d{2})(am|pm)$/i);

  if (!match) return null;

  let hours = parseInt(match[1], 10);
  let minutes = parseInt(match[2], 10);
  const modifier = match[3].toLowerCase();

  if (isNaN(hours) || isNaN(minutes)) return null;

  // Convert to 24-hour format
  if (modifier === "pm" && hours < 12) hours += 12;
  if (modifier === "am" && hours === 12) hours = 0;

  const now = new Date();
  now.setHours(hours, minutes, 0, 0);

  return now;
};

export const resetFilters = () => {
  localStorage.removeItem('clientFilters');
  localStorage.removeItem('carePartnerFilters');
  localStorage.removeItem('applicantFilters');
  localStorage.removeItem('referralFilters');
  localStorage.removeItem('prospectFilters');
  localStorage.removeItem('quickHitsFilters');
  localStorage.removeItem('careManagementFilters');
  localStorage.removeItem('awardManangementFilters');
  localStorage.removeItem('applicantActivitiesFilters');
  localStorage.removeItem('marketingActivtiesFilters');
  localStorage.removeItem('authorizationClientFilters');
  localStorage.removeItem('lastRowId');
  localStorage.removeItem('recruiterDashboardFilters');
}
export const formatQueryObj = (filter: any) => {
  const currentDate1 = new Date();
  let year = currentDate1.getFullYear();
  let month = currentDate1.getMonth() + 1;
  let day = currentDate1.getDate();

  let queryObj: any = {
    startYear: year,
    startMonth: month,
    startDay: day,
    location: filter?.location?.value || 'All'  // Assuming location works fine,
  };
  if (filter?.company && filter?.companyName?.value) {
    queryObj.company = filter.companyName.value
  }
  if (filter?.company?.value) {
    queryObj.company = filter.company.value
  }
  if (filter?.referralPartner?.value) {
    queryObj.referralPartner = filter.referralPartner.value
  }
  if (filter?.companyType?.value) {
    queryObj.companyType = filter.companyType.value
  }
  if (filter.flag) {
    queryObj.flag = filter.flag
  }
  if (filter.excludeNoActivity) {
    queryObj.excludeNoActivity = filter.excludeNoActivity
  }
  if (filter.salesType) {
    queryObj.salesType = filter.salesType.value
  }
  if (filter.leadSource) {
    queryObj.leadSource = filter.leadSource.value
  }
  const startOfWeek = new Date(currentDate1);
  startOfWeek.setDate(currentDate1.getDate() - day);
  startOfWeek.setHours(0, 0, 0, 0);


  const now = new Date();
  const dayOfWeek = now.getDay(); // Day of week (0-6, 0 is Sunday)
  const currentDate = now.getDate(); // Day of month (1-31)
  const currentMonth = now.getMonth(); // Month (0-11, 0 is January)
  const currentYear = now.getFullYear(); // Full year (YYYY)
  const getFirstDayOfWeek = () => {
    return new Date(now.setDate(now.getDate() - dayOfWeek));
  };

  const daysInMonth = (year: any, month: any) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const filterLogic: any = {
    'thisWeek': () => {
      queryObj.timeUnit = 'day';
      queryObj.span = 7;
      queryObj.startDay = getFirstDayOfWeek().getDate(); // Assuming week starts on Sunday
      queryObj.startMonth = currentMonth
    },
    'thisMonth': () => {
      queryObj.timeUnit = 'day';
      queryObj.span = daysInMonth(currentYear, currentMonth);
      queryObj.startDay = 1; // Start from the first day of the current month
      queryObj.startMonth = currentMonth

    },
    'yearToDate': () => {
      queryObj.timeUnit = 'month';
      const currentDate = new Date(); // Get the current date
      const currentYear = currentDate.getFullYear(); // Extract the current year
      const currentMonth = currentDate.getMonth();
      queryObj.span = currentMonth + 1;
      queryObj.startMonth = 0;
    },
    'lastWeek': () => {
      queryObj.timeUnit = 'day';
      queryObj.span = 7;
      queryObj.startDay = getFirstDayOfWeek().getDate() - 7; // Assuming week starts on Sunday
      queryObj.startMonth = currentMonth
    },
    'lastMonth': () => {
      queryObj.timeUnit = 'day';
      const lastMonth = currentMonth - 1;
      queryObj.span = daysInMonth(currentYear, lastMonth);
      queryObj.startDay = 1; // Start from the first day of the last month
      queryObj.startMonth = lastMonth;
    },
    'last3Months': () => {
      queryObj.timeUnit = 'month';
      queryObj.span = 3;
      queryObj.startMonth = month - 3;
    },
    'last6Months': () => {
      queryObj.timeUnit = 'month';
      queryObj.span = 6;
      queryObj.startMonth = month - 6;
    },
    'last12Months': () => {
      queryObj.timeUnit = 'month';
      queryObj.span = 12;
      queryObj.startYear = year - 1
    }
  };
  const selectedFilter = filter?.timeFrame?.value;
  if (selectedFilter && filterLogic[selectedFilter]) {
    filterLogic[selectedFilter]();
  }

  return queryObj
}

export const formatDateToDisplayAndISTISO = (inputDate: any) => {
  if (!inputDate) return { display: '', iso: '' };
  const localDate = moment.utc(inputDate).local();
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const weekdays = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
  ];
  const jsDate = localDate.toDate(); // convert back to JS Date for day/month extraction
  const day = jsDate.getDate();
  const month = months[jsDate.getMonth()];
  const year = jsDate.getFullYear();
  const weekday = weekdays[jsDate.getDay()];
  const display = `${month} ${day}, ${year}, ${weekday}`;
  return display;
};

// export const formatDateToDisplayAndISTISO = (inputDate: any) => {
//   if (!inputDate) return { display: '', iso: '' };
//   const localDate = moment.utc(inputDate).local();
//   const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//   const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//   const jsDate = localDate.toDate(); // convert back to JS Date for day/month extraction
//   const day = jsDate.getDate();
//   const month = months[jsDate.getMonth()];
//   const year = jsDate.getFullYear();
//   const weekday = weekdays[jsDate.getDay()];
//   const display = `${month} ${day}, ${year}, ${weekday}`;
//   return display;
// };
/**
 * Returns the start (Monday) and end (Sunday) date of the week for a given date.
 * @param date Optional date input; defaults to current date.
 */
export function getThisWeekRange(date: Date = new Date()): { startDate: string; endDate: string } {
  const currentDate = moment(date);
  const day = currentDate.day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

  // Calculate difference from Monday
  const diffToMonday = day === 0 ? -6 : 1 - day;

  // Start of week (Monday)
  const startDate = moment(currentDate).add(diffToMonday, "days").startOf("day").toISOString();

  // End of week (Sunday)
  const endDate = moment(startDate).add(6, "days").endOf("day").toISOString();

  return { startDate, endDate };
}
export function getThisMonthRange(date: Date = new Date()): { startDate: string; endDate: string } {
  const currentDate = moment(date);

  const startDate = currentDate.startOf("month").toISOString();
  const endDate = currentDate.endOf("month").toISOString();

  return { startDate, endDate };
}


export function getWeekStartDate(date: Date) {
  if (!date) return null;
  const dayOffset = (date.getUTCDay() + 6) % 7;
  const weekStart = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - dayOffset);
  return weekStart;
}

export function getWeekEndDate(date: Date) {
  if (!date) return null;
  const dayOffset = (date.getUTCDay() + 6) % 7;
  const weekEnd = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - dayOffset + 6);
  return weekEnd;
}
export function formatDisplayedDate(date: Date) {
  // Ensure the date is a valid Date object
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // Handle invalid dates
  if (isNaN(date.getTime())) {
    console.error("Invalid date:", date);
    return "Invalid Date";
  }

  // Date options for formatting (without weekday)
  const dateOptions = { month: 'long', day: 'numeric', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);

  // Get the day of the week
  const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });

  return `${formattedDate}, ${dayOfWeek}`;
}
const monthNames = [
  "January", "February", "March",
  "April", "May", "June", "July",
  "August", "September", "October",
  "November", "December"
];
// export function getWeekKey(weekStart: Date, weekEnd: Date) {
//   const startMonth = monthNames[weekStart.getMonth()];
//   const endMonth = monthNames[weekEnd.getMonth()];
//   const startDate = weekStart.getDate();
//   const endDate = weekEnd.getDate();
//   const year = weekStart.getFullYear();
//   return `${startMonth} ${startDate} - ${endMonth} ${endDate}, ${year}`;
// }

export function getMonthKey(value: Date | string | null | undefined) {
  if (!value) {
    return 'No Date';
  }

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) {
    return 'No Date';
  }

  const monthName = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${monthName} ${year}`;
}

export function getWeekKey(weekStart: Date, weekEnd: Date) {
  const startMonth = monthNames[weekStart.getMonth()];
  const endMonth = monthNames[weekEnd.getMonth()];
  return `${startMonth} ${weekStart.getDate()} - ${endMonth} ${weekEnd.getDate()}, ${weekStart.getFullYear()}`;
}
export function getDaysBucket(activateDate: string) {
  if (!activateDate) return 'No Date';

  const now = new Date();
  const date = new Date(activateDate);
  if (isNaN(date.getTime())) return 'Invalid Date';

  const diffInDays = Math.floor(
    (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffInDays >= 0 && diffInDays <= 30) return '1-30 Days';
  if (diffInDays >= 31 && diffInDays <= 60) return '31-60 Days';
  if (diffInDays >= 61 && diffInDays <= 90) return '61-90 Days';

  return '90+ Days';
};

export const areaChartOptions = {
  chart: {
    type: 'area',
    toolbar: { show: false },

    // 🔴 ADD THESE
    zoom: { enabled: false },
    selection: { enabled: false }
  },

  // already added earlier (keep this)
  states: {
    normal: { filter: { type: 'none' } },
    hover: { filter: { type: 'none' } },
    active: { filter: { type: 'none' } }
  },

  legend: {
    onItemClick: { toggleDataSeries: false },
    onItemHover: { highlightDataSeries: false }
  },

  dataLabels: { enabled: false },
  stroke: {
    width: 1
  },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      type: 'vertical',
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0
    }
  },
  plotOptions: {
    bar: {
      columnWidth: '45%',
      borderRadius: 4
    }
  },
  grid: {
    strokeDashArray: 4
  }
};
export const areaChartOptionsApplicants = {
  chart: {
    type: 'area',
    stacked: false,
    toolbar: { show: false },

    // ❌ disable unwanted interactions
    zoom: { enabled: false },
    selection: { enabled: false },
    pan: { enabled: false }
  },

  dataLabels: { enabled: true },

  stroke: { width: 1 },

  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      type: 'vertical',
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0
    }
  },

  grid: {
    strokeDashArray: 4
  },

  // ✅ Tooltip ON (hover only)
  tooltip: {
    enabled: true,
    y: {
      formatter: (val) => `${val}%`
    }
  },

  // ✅ Hover allowed, click/active disabled
  states: {
    hover: {
      filter: {
        type: 'lighten'
      }
    },
    active: {
      filter: {
        type: 'none'
      }
    }
  }
};
export const getInitialQueryObj = (date: Date, locations: any, filter: any) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const loc = Array.isArray(locations)
    ? locations.map((l) => l?._id).join(',')
    : '';

  return {
    startYear: year,
    startMonth: month,
    startDay: day,
    location: filter?.location?.value === '0' ? loc : filter?.location?.value
  };
};
// utils/dateFilters.js

export const getFirstDayOfWeek = (date: Date) => {
  const dayOfWeek = date.getDay();
  const diff = date.getDate() - dayOfWeek;
  return new Date(date.setDate(diff));
};

export const daysInMonth = (year: any, month: any) =>
  new Date(year, month, 0).getDate();

export const applyFilterLogic = (filterKey: String, queryObj: any, currentDate: any) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;

  switch (filterKey) {
    case 'thisWeek':
      queryObj.timeUnit = 'day';
      queryObj.span = 7;
      queryObj.startDay = getFirstDayOfWeek(new Date(currentDate)).getDate();
      queryObj.startMonth = month;
      break;

    case 'thisMonth':
      queryObj.timeUnit = 'day';
      queryObj.span = daysInMonth(year, month);
      queryObj.startDay = 1;
      queryObj.startMonth = month;
      break;

    case 'yearToDate':
      queryObj.timeUnit = 'month';
      queryObj.span = month;
      queryObj.startMonth = 1;
      break;

    case 'lastWeek':
      queryObj.timeUnit = 'day';
      queryObj.span = 7;
      queryObj.startDay =
        getFirstDayOfWeek(new Date(currentDate)).getDate() - 7;
      queryObj.startMonth = month;
      break;

    case 'lastMonth':
      const lastMonth = month - 1;
      queryObj.timeUnit = 'day';
      queryObj.span = daysInMonth(year, lastMonth);
      queryObj.startDay = 1;
      queryObj.startMonth = lastMonth;
      break;

    case 'last3Months':
      queryObj.timeUnit = 'month';
      queryObj.span = 3;
      queryObj.startMonth = month - 3;
      break;

    case 'last6Months':
      queryObj.timeUnit = 'month';
      queryObj.span = 6;
      queryObj.startMonth = month - 6;
      break;

    case 'last12Months':
      queryObj.timeUnit = 'month';
      queryObj.span = 12;
      queryObj.startYear = year - 1;
      break;

    default:
      console.warn(`Unhandled filter: ${filterKey}`);
  }
};
export const filterChartDataByToday = (labels = [], counts1 = [], counts2 = [], cutoffDate = new Date()) => {
  if (!Array.isArray(labels) || !Array.isArray(counts1)) {
    return { filteredHeaders: [], filteredCounts: [] };
  }

  const today = new Date(cutoffDate);
  today.setHours(0, 0, 0, 0);

  const filteredHeaders = labels.filter(label => {
    const labelDate = new Date(label);
    return !isNaN(labelDate.getTime()) && labelDate <= today;
  });

  const lastIndex = filteredHeaders.length;
  const filteredWon = counts1.slice(0, lastIndex);
  const filteredLost = counts2.slice(0, lastIndex);

  return { filteredHeaders, filteredWon, filteredLost };
};

export const getDayLabelFromDate = (inputDate: string | Date) => {
  if (!inputDate) return 0;

  const givenDate = new Date(inputDate);
  const today = new Date();

  // remove time part to get exact day difference
  givenDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - givenDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  const days = diffDays >= 0 ? diffDays : 0;
  return `Day ${days}`;
};
export function getDateBucket(inputDate: string | Date): string {
  if (!inputDate) return '';

  const date = new Date(inputDate);
  if (isNaN(date.getTime())) return '';

  const today = new Date();

  const startOfToday = new Date(today);
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date(today);
  endOfToday.setHours(23, 59, 59, 999);

  const startOfWeek = new Date(today);
  startOfWeek.setHours(0, 0, 0, 0);
  startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday start

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);

  const startOfNextWeek = new Date(endOfWeek);
  startOfNextWeek.setDate(endOfWeek.getDate() + 1);
  startOfNextWeek.setHours(0, 0, 0, 0);

  const endOfNextWeek = new Date(startOfNextWeek);
  endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
  endOfNextWeek.setHours(23, 59, 59, 999);

  if (date >= startOfToday && date <= endOfToday) {
    return 'Today';
  }

  if (date >= startOfWeek && date <= endOfWeek) {
    return 'This Week';
  }

  if (date >= startOfNextWeek && date <= endOfNextWeek) {
    return 'Next Week';
  }

  return '';
}
type CardItem = {
  _id: string;
  label: string;
  value?: string | number | boolean | Date | null;
};

type ProgressCard = {
  _id?: string;
  cardName?: unknown;
  cardItems?: CardItem[];
};

export const formatMetricNumber = (value: any) => {
  const numericValue = Number(value ?? 0);
  if (!Number.isFinite(numericValue)) return '0';
  return Number.isInteger(numericValue) ? String(numericValue) : numericValue.toFixed(1).replace(/\.0$/, '');
};

export const formatPercent = (value: any) => `${formatMetricNumber(value)}%`;

export const formatPoints = (value: any) => `${Number(value) > 0 ? '+' : ''}${formatMetricNumber(value)} pts`;

export const formatTouchesLabel = (count: any) => `${count} ${count === 1 ? 'touch' : 'touches'} last 30 days`;

export const getTierTone = (tier: any) => {
  if (tier === 'A') return 'danger';
  if (tier === 'B') return 'warning';
  if (tier === 'C') return 'default';
  return 'default';
};

export const buildLastActivityLine = (item: any) => {
  if (item?.lastActivityDisplay && item?.lastActivityType) {
    return `Last activity: ${item.lastActivityDisplay} · ${item.lastActivityType}`;
  }

  if (item?.lastActivityDisplay) {
    return `Last activity: ${item.lastActivityDisplay}`;
  }

  if (item?.lastActivityType) {
    return `Last activity: ${item.lastActivityType}`;
  }

  return '';
};


export const getProspectCardItemLabelById = (
  progress: ProgressCard[] = [],
  itemId?: string
): string => {
  if (!Array.isArray(progress) || !itemId) return '';

  for (const card of progress) {
    const foundItem = card.cardItems?.find(
      (item) => String(item._id) === String(itemId)
    );

    if (foundItem) {
      return foundItem.label || '';
    }
  }

  return '';
};
export const stripHtmlContent = (value: string) =>
  value
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, '')
    .trim();


export const dashboardThemeVars = (theme: any, alpha: any) => ({
  '--cm-bg': theme.palette.background.default,
  '--cm-surface': theme.palette.background.paper,
  '--cm-surface-muted': alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.12 : 0.05),
  '--cm-surface-soft': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.035),
  '--cm-border': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.2 : 0.12),
  '--cm-border-strong': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.28 : 0.18),
  '--cm-text-primary': theme.palette.text.primary,
  '--cm-text-secondary': theme.palette.text.secondary,
  '--cm-text-muted': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.7 : 0.62),
  '--cm-accent': theme.palette.primary.main,
  '--cm-accent-soft': alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.22 : 0.1),
  '--cm-success': theme.palette.success.main,
  '--cm-success-soft': alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.22 : 0.12),
  '--cm-warning': theme.palette.warning.main,
  '--cm-warning-soft': alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.22 : 0.14),
  '--cm-danger': theme.palette.error.main,
  '--cm-danger-soft': alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.22 : 0.12),
  '--cm-info': theme.palette.info.main,
  '--cm-info-soft': alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.22 : 0.12),
  '--cm-shadow': theme.shadows[2],
  '--cm-shadow-hover': theme.shadows[4],
  '--cm-radius': '16px',
  '--cm-radius-inner': '12px',
});
export const getInitials = (firstName = '', lastName = '') => {
  const firstInitial = firstName.trim().charAt(0);
  const lastInitial = lastName.trim().charAt(0);
  return `${firstInitial}${lastInitial}`.toUpperCase();
};
export const validateFileName = (name: string) => {
  if (!name || name.trim() === '') {
    return 'File name is required.';
  }
  if (name.length > 150) {
    return 'File name should not exceed 50 characters.';
  }
  return '';
};
